import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      this.authenticationService.isLoggedIn() &&
      !request.headers.get('Authorization')
    ) {
      const currentAutorization =
        this.authenticationService.currentAuthorizationValue;
      const req = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentAutorization.token}`
        }
      });
      return next.handle(req);
    }

    return next.handle(request);
  }
}
